import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function PrivacyPolicy() {
  const lastUpdated = "28/06/2026";

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar forceSolid />

      <main className="pt-20 pb-16">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          {/* Breadcrumb */}
          <nav className="flex items-center gap-2 text-xs text-foreground-400 mb-8">
            <Link to="/" className="hover:text-foreground-600 transition-colors no-underline">Trang chủ</Link>
            <i className="ri-arrow-right-s-line text-sm"></i>
            <span className="text-foreground-600">Chính sách bảo mật</span>
          </nav>

          {/* Header */}
          <div className="mb-10">
            <h1 className="font-heading font-bold text-3xl text-foreground-950 mb-3">Chính sách bảo mật</h1>
            <p className="text-sm text-foreground-500">Cập nhật lần cuối: {lastUpdated}</p>
          </div>

          {/* Content */}
          <article className="prose prose-sm max-w-none text-foreground-700 space-y-8">
            {/* Intro */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">1. Giới thiệu</h2>
              <p className="text-sm leading-relaxed">
                Chào mừng bạn đến với <strong>Vietnam.cv</strong> — nền tảng kết nối việc làm miễn phí dành cho người lao động Việt Nam. 
                Chúng tôi cam kết bảo vệ quyền riêng tư và thông tin cá nhân của bạn. Chính sách bảo mật này giải thích cách chúng tôi thu thập, 
                sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân khi bạn sử dụng dịch vụ của chúng tôi.
              </p>
              <p className="text-sm leading-relaxed mt-3">
                Bằng việc sử dụng Vietnam.cv, bạn đồng ý với các điều khoản trong chính sách bảo mật này. 
                Nếu bạn không đồng ý, vui lòng không sử dụng dịch vụ của chúng tôi.
              </p>
            </section>

            {/* Information Collection */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">2. Thông tin chúng tôi thu thập</h2>
              
              <h3 className="font-heading text-base font-semibold text-foreground-900 mt-5 mb-2">2.1. Thông tin bạn cung cấp trực tiếp</h3>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li><strong>Thông tin tài khoản:</strong> Họ tên, địa chỉ email, số điện thoại khi bạn đăng ký tài khoản.</li>
                <li><strong>Thông tin hồ sơ cá nhân:</strong> Ngày sinh, giới tính, địa chỉ, kinh nghiệm làm việc, học vấn, kỹ năng, chứng chỉ khi bạn tạo CV trực tuyến.</li>
                <li><strong>Thông tin doanh nghiệp:</strong> Tên công ty, địa chỉ, thông tin liên hệ khi doanh nghiệp đăng ký tài khoản.</li>
                <li><strong>Thông tin ứng tuyển:</strong> Thư xin việc, CV đính kèm khi bạn ứng tuyển vào các vị trí tuyển dụng.</li>
                <li><strong>Thông tin liên hệ:</strong> Nội dung tin nhắn khi bạn liên hệ với chúng tôi qua biểu mẫu liên hệ.</li>
              </ul>

              <h3 className="font-heading text-base font-semibold text-foreground-900 mt-5 mb-2">2.2. Thông tin thu thập tự động</h3>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li><strong>Dữ liệu truy cập:</strong> Địa chỉ IP, loại trình duyệt, hệ điều hành, thời gian truy cập, các trang đã xem.</li>
                <li><strong>Cookie và công nghệ tương tự:</strong> Chúng tôi sử dụng cookie để duy trì phiên đăng nhập và cải thiện trải nghiệm người dùng.</li>
              </ul>
            </section>

            {/* Purpose */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">3. Mục đích sử dụng thông tin</h2>
              <p className="text-sm leading-relaxed">Chúng tôi sử dụng thông tin của bạn cho các mục đích sau:</p>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed mt-2">
                <li>Cung cấp và duy trì dịch vụ kết nối việc làm.</li>
                <li>Xác thực tài khoản và bảo mật hệ thống.</li>
                <li>Hiển thị thông tin ứng viên cho nhà tuyển dụng khi bạn ứng tuyển.</li>
                <li>Hiển thị tin tuyển dụng cho người tìm việc.</li>
                <li>Gửi thông báo về trạng thái ứng tuyển và các cập nhật liên quan.</li>
                <li>Cải thiện chất lượng dịch vụ và trải nghiệm người dùng.</li>
                <li>Phát hiện và ngăn chặn các hành vi gian lận, lạm dụng.</li>
                <li>Tuân thủ các yêu cầu pháp lý.</li>
              </ul>
            </section>

            {/* Data Sharing */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">4. Chia sẻ thông tin</h2>
              <p className="text-sm leading-relaxed">
                Chúng tôi <strong>KHÔNG bán, trao đổi hoặc cho thuê</strong> thông tin cá nhân của bạn cho bên thứ ba vì mục đích thương mại. 
                Thông tin chỉ được chia sẻ trong các trường hợp sau:
              </p>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed mt-2">
                <li><strong>Với nhà tuyển dụng:</strong> Khi bạn ứng tuyển vào một vị trí, hồ sơ của bạn (CV, thư xin việc) sẽ được chia sẻ với nhà tuyển dụng đăng tin đó.</li>
                <li><strong>Với ứng viên:</strong> Khi doanh nghiệp đăng tin, thông tin công ty và mô tả công việc sẽ hiển thị công khai.</li>
                <li><strong>Yêu cầu pháp lý:</strong> Khi có yêu cầu từ cơ quan nhà nước có thẩm quyền theo quy định pháp luật.</li>
                <li><strong>Bảo vệ quyền lợi:</strong> Khi cần thiết để bảo vệ quyền, tài sản hoặc sự an toàn của Vietnam.cv, người dùng hoặc công chúng.</li>
              </ul>
            </section>

            {/* Data Storage & Security */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">5. Lưu trữ và bảo mật dữ liệu</h2>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed">
                <li>Dữ liệu của bạn được lưu trữ trên các máy chủ an toàn với các biện pháp bảo vệ kỹ thuật và tổ chức phù hợp.</li>
                <li>Chúng tôi sử dụng mã hóa SSL/TLS để bảo vệ dữ liệu trong quá trình truyền tải.</li>
                <li>Truy cập vào dữ liệu cá nhân được giới hạn cho các nhân viên và nhà thầu cần thiết để vận hành dịch vụ.</li>
                <li>Mặc dù chúng tôi áp dụng các biện pháp bảo mật hợp lý, không có phương thức truyền tải hoặc lưu trữ điện tử nào an toàn tuyệt đối 100%.</li>
              </ul>
            </section>

            {/* Data Retention */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">6. Thời gian lưu trữ dữ liệu</h2>
              <p className="text-sm leading-relaxed">
                Chúng tôi lưu trữ thông tin cá nhân của bạn trong thời gian tài khoản của bạn hoạt động hoặc khi cần thiết 
                để cung cấp dịch vụ. Khi bạn xóa tài khoản, chúng tôi sẽ xóa hoặc ẩn danh dữ liệu của bạn trong thời gian 
                hợp lý, trừ khi pháp luật yêu cầu lưu trữ lâu hơn.
              </p>
            </section>

            {/* User Rights */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">7. Quyền của người dùng</h2>
              <p className="text-sm leading-relaxed">Bạn có các quyền sau đối với dữ liệu cá nhân của mình:</p>
              <ul className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed mt-2">
                <li><strong>Quyền truy cập:</strong> Bạn có thể xem thông tin cá nhân của mình trong phần Tài khoản.</li>
                <li><strong>Quyền chỉnh sửa:</strong> Bạn có thể cập nhật thông tin cá nhân bất cứ lúc nào.</li>
                <li><strong>Quyền xóa:</strong> Bạn có thể yêu cầu xóa tài khoản và dữ liệu liên quan bằng cách liên hệ với chúng tôi.</li>
                <li><strong>Quyền khiếu nại:</strong> Nếu bạn có khiếu nại về cách chúng tôi xử lý dữ liệu, vui lòng liên hệ trực tiếp với chúng tôi.</li>
              </ul>
            </section>

            {/* Cookies */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">8. Cookie</h2>
              <p className="text-sm leading-relaxed">
                Chúng tôi sử dụng cookie để duy trì phiên đăng nhập và ghi nhớ tùy chọn của bạn. 
                Bạn có thể kiểm soát cookie thông qua cài đặt trình duyệt. Việc tắt cookie có thể ảnh hưởng 
                đến một số tính năng của trang web.
              </p>
            </section>

            {/* Children Privacy */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">9. Bảo vệ trẻ em</h2>
              <p className="text-sm leading-relaxed">
                Dịch vụ của chúng tôi không dành cho trẻ em dưới 16 tuổi. Chúng tôi không cố ý thu thập 
                thông tin cá nhân từ trẻ em dưới 16 tuổi. Nếu bạn là phụ huynh và phát hiện con mình đã 
                cung cấp thông tin cho chúng tôi, vui lòng liên hệ để chúng tôi xóa thông tin đó.
              </p>
            </section>

            {/* Changes */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">10. Thay đổi chính sách</h2>
              <p className="text-sm leading-relaxed">
                Chúng tôi có thể cập nhật chính sách bảo mật này theo thời gian. Khi có thay đổi quan trọng, 
                chúng tôi sẽ thông báo qua email hoặc hiển thị thông báo trên trang web. Việc tiếp tục sử 
                dụng dịch vụ sau khi thay đổi có hiệu lực đồng nghĩa với việc bạn chấp nhận chính sách mới.
              </p>
            </section>

            {/* Contact */}
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-950 mb-3">11. Liên hệ</h2>
              <p className="text-sm leading-relaxed">
                Nếu bạn có bất kỳ câu hỏi hoặc yêu cầu nào về chính sách bảo mật này, vui lòng liên hệ với chúng tôi qua:
              </p>
              <ul className="list-disc pl-5 space-y-1 text-sm leading-relaxed mt-2">
                <li>Email: <a href="mailto:privacy@vietnam.cv" className="text-primary-600 hover:text-primary-700">privacy@vietnam.cv</a></li>
                <li>Thông qua biểu mẫu liên hệ trên trang web</li>
              </ul>
            </section>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
}